import axios from 'axios';

export default {
  template: "#vue-returns-portal",
  delimiters: ['${', '}'],
  props: [
    "customer_id",
    "customer_email"
  ],
  data() {
    return {
      customer: {
        id: this.customer_id || null,
        email: this.customer_email || '',
      },
      order_number: null,
      postal_code: '',
      submitting: false,

      has_ship_return: false,
      has_in_person_return: false,

      step: 'initiation',
      order: null,
      initiation_error: null,
      not_eligible: false,
      shipping_error: null,
      completion_error: null,
      return_contents: {},
      return_methods: {},
      shipping_summary: null,
      return_confirmation: null
    }
  },
  computed: {
    initiation_valid() {
      if (Object.keys(this.return_contents).length === 0) {
        return false
      }
      for (let k of Object.keys(this.return_contents)) {
        if (!this.return_contents[k].reason) {
          return false
        }
      }
      return true
    },
    shipment_totals() {
      let out = {}
      for (let store of Object.keys(this.shipping_summary)) {
        out[store] = []
        for (let shipment_idx in this.shipping_summary[store]) {
          let shipment = this.shipping_summary[store][shipment_idx]
          let product_value = 0.0
          for (let line of shipment.line_items) {
            product_value += this.order.item_info[line.shopify_line_id].discountedUnitPrice
          }
          out[store].push(product_value * (1.0 + this.order.taxRate) / 100)
        }
      }
      return out
    },
    expected_refund() {
      let shipping_cost = 0
      let product_value = 0
      for (let shipment of Object.entries(this.return_methods)) {
        if (!shipment[1].method) {
          return null
        }
      }
      for (let store of Object.keys(this.shipping_summary)) {
        for (let shipment_idx in this.shipping_summary[store]) {
          let shipment = this.shipping_summary[store][shipment_idx]
          for (let line of shipment.line_items) {
            product_value += this.order.item_info[line.shopify_line_id].discountedUnitPrice
          }
          for (let method of shipment.rates) {
            if (method.key === this.return_methods[`${store}-${shipment_idx}`].method) {
              shipping_cost += (method.cost * 100)
            }
          }
        }
      }
      return {
        products: product_value,
        taxes: product_value * this.order.taxRate,
        shipping: shipping_cost
      }
    }
  },
  methods: {
    is_final_sale(shopify_id){
      return this.order.item_info[shopify_id].is_final_sale || this.order.item_info[shopify_id].is_clearance
    },
    store_name(number) {
      let i = this.$store.getters.store_info(number)
      return i ? i.store_name : `${this.$store.state.locale === 'fr' ? 'Magasin' : 'Store'} #${number}`
    },
    add_to_return(mos_id, shopify_line_id, store_number, upc) {
      this.return_contents[mos_id] = {
        store_number: store_number,
        reason: null,
        upc: upc,
        shopify_line_id: shopify_line_id
      }
    },
    remove_from_return(mos_id) {
      delete this.return_contents[mos_id]
    },
    complete_initiation() {
      if (this.submitting) {
        return
      }
      this.submitting = true
      let return_stores = {}
      let return_payload = {}

      for (let line of Object.entries(this.return_contents)) {
        let store = line[1].store_number
        if (!(store in return_stores)) {
          return_stores[store] = []
          return_payload[store] = []
        }
        return_stores[store].push({
          mos_id: line[0],
          shopify_line_id: line[1].shopify_line_id,
          upc: line[1].upc,
          reason: line[1].reason,
        })
        return_payload[store].push(line[1].upc)
      }

      axios.post('/apps/api/returns/packaging',
          {shipments: return_payload, postal_code: this.order.shipping_address.zip}).then(
          resp => {
            this.step = 'shipping'
            this.submitting = false

            let output = {}
            for (let store of Object.keys(resp.data.rates)) {
              if (!(store in output)) {
                output[store] = []
              }
              for (let shipment_idx in resp.data.rates[store]) {
                let shipment = resp.data.rates[store][shipment_idx]
                let s = Object.assign({}, shipment)
                s.line_items = []
                s.unmatched_upcs = s.upcs.slice()
                output[store].push(s)
                this.return_methods[`${store}-${shipment_idx}`] = {method: null, mos_ids: []}
              }
              // match all the shopify line items, mos_ids, and return reasons back up to the routed shipment lines
              for (let line of return_stores[store]) {
                let matched = false
                for (let shipment_idx in output[store]) {
                  let shipment = output[store][shipment_idx]
                  for (let idx in shipment.unmatched_upcs) {
                    if (parseInt(line.upc) && shipment.unmatched_upcs[idx] === parseInt(line.upc)) {
                      shipment.line_items.push(line)
                      shipment.unmatched_upcs[idx] = null
                      this.return_methods[`${store}-${shipment_idx}`].mos_ids.push(line.mos_id)
                      matched = true
                      break
                    }
                  }
                  if (matched) {
                    break
                  }
                }
              }
            }
            this.shipping_summary = output
          },
          err => {
            this.submitting = false
            this.shipping_error = true
          })
    },
    order_search(evt) {
      evt.preventDefault()
      if (this.submitting) {
        return
      }
      if (this.$refs['initiation_form'].reportValidity()) {
        this.submitting = true
        this.initiation_error = false
        axios.get('/apps/api/returns/order-search',
            {
              params: {
                order_number: this.order_number,
                email: this.customer.email,
                postal_code: this.postal_code,
                locale: this.$store.state.lang
              }
            })
        .then(
            resp => {
              this.step = 'initiation'
              this.order = resp.data.order
              let age = (new Date().getTime() - new Date(this.order.created_at).getTime()) / 3600 / 1000 / 24
              this.not_eligible = age > 30
              this.submitting = false
            }, err => {
              this.submitting = false
              this.initiation_error = err.response.status === 404 ? 'NOT_FOUND' : true
            }
        )
      }
    },
    open_returns() {
      let pl = {
        order_number: this.order.order_number,
        tax_rate: this.order.taxRate,
        return_shipments: {},
        locale: this.$store.state.lang
      }
      this.has_ship_return = false
      this.has_in_person_return = false
      for (let store of Object.keys(this.shipping_summary)) {
        if (!(store in pl.return_shipments)) {
          pl.return_shipments[store] = []
        }
        for (let s_idx in this.shipping_summary[store]) {
          let ship = this.shipping_summary[store][s_idx]
          let selected = this.return_methods[`${store}-${s_idx}`]
          let rate = 0.0
          if (selected.method !== 'in-store') {
            this.has_ship_return = true
            for (let service of ship.rates) {
              if (service.key === selected.method) {
                rate = service.cost
              }
            }
          } else {
            this.has_in_person_return = true
          }
          let reasons = {}
          for (let mos_id of selected.mos_ids) {
            reasons[mos_id] = this.return_contents[mos_id].reason
          }
          let pack = {
            package: {
              length: ship.package.length,
              width: ship.package.width,
              height: ship.package.height,
              weight: ship.package.weight
            },
            method: selected.method,
            rate: rate,
            mos_ids: reasons
          }
          pl.return_shipments[store].push(pack)
        }
      }

      this.submitting = true
      axios.post('/apps/api/returns/open', pl).then(
          resp => {
            this.return_confirmation = resp.data.return_id
            this.submitting = false
            this.completion_error = null
            this.step = 'complete'
          },
          err => {
            this.submitting = false
            console.log(err)
            console.log(err.response)
            this.completion_error = err.response.data.error
          })
    }
  },
  mounted() {

  }
}